import { Component, OnInit, EventEmitter, Input, Output } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AwsService } from "../../providers/appsyncservice/aws.service";
import { LoginService } from "../../service/login/login.service";
import { AuthService } from "../../guard/auth.service";
import { AppConstants } from "../../constants/app-constants";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { DateutilService } from "../../service/dateutil/dateutil.service";
import { TokenRefreshService } from "../../service/tokenRefreshService";
var CryptoJS = require("crypto-js");

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  errorData: boolean = false;
  model: any = {};
  user_type: number;
  loginResult: any = {};

  constructor(
    public router: Router,
    public awserviceProvider: AwsService,
    protected activatedRoute: ActivatedRoute,
    private loginService: LoginService,
    private auth: AuthService,
    private http: HttpClient,
    private dateutilService: DateutilService,
    private tokenRefreshService: TokenRefreshService
  ) { }

  ngOnInit() {
    // this.activatedRoute.fragment.subscribe(async (fragment: string) => {
    //   this.oauthService.parseFragment(fragment);
    //   this.router.navigateByUrl(this.oauthService.getUrlBeforeAuthentication());
    // });
    this.checkLoginStatus();
  }

  private checkLoginStatus(): void {
    const LoggedIn = localStorage.getItem('LoggedIn') === 'true';
    const userType = localStorage.getItem('LoggedInUserType');

    if (LoggedIn) {
      // Redirect based on user type
      this.redirectBasedOnUserType(userType);
    }
  }

  private redirectBasedOnUserType(userType: string): void {
    switch (userType) {
      case '0':
        this.router.navigate(['./pages/dashboard']);
        break;
      case '4':
        this.router.navigate(['./pages/vehiclems']);
        break;
      case '5':
        this.router.navigate(['./pages/wellness']);
        break;
      default:
        this.router.navigate(['./pages/dashboard']);
        break;
    }
  }

  localLogin() {
    let username = 'admin';
    let password = 'rntbci2018';
    const loginUrl = environment.smsUrl[window.location.origin] + '/mobileloginapi';
    const payload = {
      user_name: username,
      password: password
    };
    this.http.post(loginUrl, payload, { headers: { 'x-platform': 'mobile' } }).subscribe(
      (response: any) => {
        this.loginResult = response;
        if (this.loginResult != null && this.loginResult.user_name !== null && this.loginResult.user_name !== undefined) {
          var hasedpass = this.loginResult.password;
          var bytes = CryptoJS.AES.decrypt(hasedpass, AppConstants.cryptoKey);
          var plaintext = bytes.toString(CryptoJS.enc.Utf8);
          if (plaintext === password) {
            // Save PgRest tokens and schedule refresh
            localStorage.setItem('pg_refresh_token', this.loginResult.refresh_token);

            if (this.loginResult.user_type === 0) {
              this.user_type = 0;
              this.loginService.setUserType(0);
              this.auth.sendToken(username, "0", this.loginResult.token);
              this.router.navigate(["./pages/dashboard"]);
            } else if (this.loginResult.user_type === 1 || this.loginResult.user_type === 2) {
              this.errorData = true;
            } else if (this.loginResult.user_type === 4) {
              // console.log("login success", password)
              this.loginService.setUserType(4);
              this.user_type = 4;
              this.auth.sendToken(username, "4", this.loginResult.token);
              this.router.navigate(["./pages/vehiclems"]);
            } else if (this.loginResult.user_type === 5) {
              // console.log("login success", password)
              this.loginService.setUserType(5);
              this.user_type = 5;
              this.auth.sendToken(username, "5", this.loginResult.token);
              this.router.navigate(["./pages/wellness"]);
            }
            this.dateutilService.getHolidayList();
          } else {
            this.errorData = true;
          }
        } else {
          this.errorData = true;
        }
      },
      (error) => {
        console.error('SMS Login error:', error);
        this.errorData = true;
      }
    );

  }

  oktaSignIn() {
    let hostUrl = window.location.href;
    let redirectUrl = window.location.origin + "/callback";
    if (hostUrl.includes('localhost')) {
      sessionStorage.setItem('envEndpoint', 'localhost:4200');
    } else if (hostUrl.includes('dev')) {
      sessionStorage.setItem('envEndpoint', 'https://mc0-safecab-app.dev.apps.renault.com');
    } else if (hostUrl.includes('int')) {
      sessionStorage.setItem('envEndpoint', 'https://mc0-safecab-app.int.apps.renault.com');
    } else if (hostUrl.includes('ope')) {
      sessionStorage.setItem('envEndpoint', 'https://mc0-safecab-app.ope.apps.renault.com');
    }
    let currentEnvEndpoint = sessionStorage.getItem('envEndpoint');
    let authorizationUrl = environment.oktaConfig.loginUrl[currentEnvEndpoint];
    let clientId = environment.oktaConfig.clientsId[currentEnvEndpoint];
    let scope = environment.oktaConfig.scope;
    let responseType = "code";
    let state = this.generateState(16);
    window.location.href = `${authorizationUrl}?client_id=${clientId}&scope=${scope}&response_type=${responseType}&redirect_uri=${redirectUrl}&state=${state}`;
  }

  generateState(length) {
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    let charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  removeError() {
    this.errorData = false;
  }
}
